export default "__VITE_ASSET__DZEMVOgG__"